import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Commune {
  name: string;
  api_token: string;
}

export interface CommuneListInfor {
  errors: unknown;
  commune: Commune;
  isAuthenticated: boolean;
}

@Module
export default class CommuneModule
  extends VuexModule
  implements CommuneListInfor
{
  errors = {};
  commune = {} as Commune;
  isAuthenticated = !!JwtService.getToken();

  get Communes() {
    return this.communesListData;
  }

  @Mutation
  [Mutations.COMMUNES_LIST_DATA](Communes) {
    this.communesListData = Communes;
  }

  @Action
  [Actions.COMMUNE_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/commune/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.COMMUNES_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.COMMUNE_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/commune", payload)
        .then((data) => {
          this.context.commit(Mutations.COMMUNES_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.COMMUNE_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("gis/commune", payload, "delete", payload)
        .then((data) => {
          this.context.commit(Mutations.COMMUNES_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.COMMUNE_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("gis/commune", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.COMMUNES_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
